import { Component, OnInit, OnDestroy } from '@angular/core';

import { NotificationService, BackgroundInfoService } from 'src/app/shared/services';
import { ModalService } from 'src/app/shared/modules/modal';
import { ClosableModalWithErrorResponseModel } from '../../base/closable-modal-with-error-response-model';
import { CreateBackgroundInfoTemplate, CreateBackgroundInfoTemplatePayload } from 'src/app/shared/models';

@Component({
  selector: 'create-template-modal',
  templateUrl: './create-template-modal.component.html',
})
export class CreateTemplateModalComponent
  extends ClosableModalWithErrorResponseModel<any>
  implements OnInit, OnDestroy {
  data: CreateBackgroundInfoTemplatePayload;
  template = new CreateBackgroundInfoTemplate();

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _backgroundInfoService: BackgroundInfoService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getUseCaseKey(isPlural: boolean = false): string {
    return this._backgroundInfoService.getTranslationKeyByBackInfoType(this.data.useCase, isPlural);
  }

  getCreateTemplateModalTitle(): string {
    const useCaseKey = this.getUseCaseKey().toLowerCase();
    return `background_info.create_${useCaseKey.replace('global.', '')}_background_info_template`;
  }

  getObjectCodeTranslationKey(): string {
    return this._backgroundInfoService.getObjectCodeTranslationKey(this.data.useCase);
  }

  getJurisdictionIsoCode(): string {
    return this._backgroundInfoService.getJurisdictionIsoCode(this.data.activeJurisdiction);
  }

  isTransactionType(): boolean {
    return this._backgroundInfoService.isTransactionType(this.data.useCase);
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    if (this.data && this.data.activeJurisdiction && this.data.activeJurisdiction.jurisdiction && this.data.activeJurisdiction.jurisdiction.countryId) {
      this.template.jurisdictionId = this.data.activeJurisdiction.jurisdiction.countryId;
    } else {
      delete this.template.jurisdictionId;
    }

    this._backgroundInfoService
      .createTemplate(this.data.objectId, this.data.useCase, this.template)
      .subscribe(() => {
        this.closeAllModals();
        this.success();
      });
  }
}
